import React from 'react';
import useApp from '../../store/app/appContext';
import UsersProvider from '../../store/users/usersProvider';
import ClinicsProvider from '../../store/clinics/clinicsProvider';
import PageWrapper from '../../containers/app/PageWrapper';
import StaffList from '../../containers/staff/StaffList';

function StaffManagerPage() {  

  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';
  
  return (
    <UsersProvider>
      <ClinicsProvider>
        <PageWrapper navbar title='Staff Manager'>
          <StaffList />
        </PageWrapper>
      </ClinicsProvider>
    </UsersProvider>
  )
}

export default StaffManagerPage;
